import {
  AdCreation,
  AdCreationPreview,
  Store,
  ProductCollections,
  LocalInventory,
  Products,
  Feeds,
  LocationTargeting,
  AgeRangeTargeting,
  GenderTargeting,
  AdSchedule,
  AdScheduleWithBidAdjustments,
  StartEndDates,
  AdDistribution,
  Audience,
  Interest,
  Topics,
  PredictiveTargeting,
  CompanyName,
  JobFunction,
  Industry,
  ConversionGoals,
  Budget,
  BidStrategy,
  BidValue,
  Languages,
  AudienceSignal,
  Images,
  LongHeadlinesSummary,
  DescriptionsSummary,
  HeadlinesSummary,
  StoreInfo,
  ListingGroup,
  AutoGeneratedAssets,
  UrlOptions,
  BidTarget,
  FinalURLExpansions,
  Keywords,
  SearchThemes,
  CostPerSale,
  UrlRules,
  Genre,
  NewCustomerAcquisition,
  Videos,
  Disclaimer,
  Colors,
} from './components';

export const summaryPageComponentTypes = {
  'ad-creation': AdCreation,
  'ad-creation-preview': AdCreationPreview,
  store: Store,
  'product-collections': ProductCollections,
  'local-inventory': LocalInventory,
  feeds: Feeds,
  products: Products,
  'location-targeting': LocationTargeting,
  'age-range-targeting': AgeRangeTargeting,
  'gender-targeting': GenderTargeting,
  'genre-targeting': Genre,
  'ad-schedule': AdSchedule,
  'ad-schedule-with-bid-adjustments': AdScheduleWithBidAdjustments,
  'start-end-dates': StartEndDates,
  'ad-distribution': AdDistribution,
  interest: Interest,
  topics: Topics,
  audience: Audience,
  company: CompanyName,
  industry: Industry,
  'job-function': JobFunction,
  'predictive-targeting': PredictiveTargeting,
  'conversion-goals': ConversionGoals,
  budget: Budget,
  'bid-strategy': BidStrategy,
  'bid-value': BidValue,
  languages: Languages,
  'audience-signal': AudienceSignal,
  images: Images,
  'long-headlines': LongHeadlinesSummary,
  descriptions: DescriptionsSummary,
  headlines: HeadlinesSummary,
  'store-info': StoreInfo,
  'listing-group': ListingGroup,
  'auto-generated-assets': AutoGeneratedAssets,
  'url-options': UrlOptions,
  'bid-target': BidTarget,
  'final-url-expansions': FinalURLExpansions,
  keywords: Keywords,
  'search-themes': SearchThemes,
  'cost-per-sale': CostPerSale,
  'url-rules': UrlRules,
  'new-customer-acquisition': NewCustomerAcquisition,
  videos: Videos,
  disclaimer: Disclaimer,
  colors: Colors,
};
